/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScreeningFlowTestEntitySelection } from './InternalApiScreeningFlowTestEntitySelection';
import {
    InternalApiScreeningFlowTestEntitySelectionFromJSON,
    InternalApiScreeningFlowTestEntitySelectionFromJSONTyped,
    InternalApiScreeningFlowTestEntitySelectionToJSON,
    InternalApiScreeningFlowTestEntitySelectionToJSONTyped,
} from './InternalApiScreeningFlowTestEntitySelection';

/**
 * 
 * @export
 * @interface InternalApiScreeningFlowTest
 */
export interface InternalApiScreeningFlowTest {
    /**
     * 
     * @type {InternalApiScreeningFlowTestEntitySelection}
     * @memberof InternalApiScreeningFlowTest
     */
    entitySelection: InternalApiScreeningFlowTestEntitySelection;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScreeningFlowTest
     */
    clearanceRuleHandles?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningFlowTest
     */
    goodlistEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScreeningFlowTest
     */
    useOnlyScreenedEntities?: boolean;
}

/**
 * Check if a given object implements the InternalApiScreeningFlowTest interface.
 */
export function instanceOfInternalApiScreeningFlowTest(value: object): value is InternalApiScreeningFlowTest {
    if (!('entitySelection' in value) || value['entitySelection'] === undefined) return false;
    return true;
}

export function InternalApiScreeningFlowTestFromJSON(json: any): InternalApiScreeningFlowTest {
    return InternalApiScreeningFlowTestFromJSONTyped(json, false);
}

export function InternalApiScreeningFlowTestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningFlowTest {
    if (json == null) {
        return json;
    }
    return {
        
        'entitySelection': InternalApiScreeningFlowTestEntitySelectionFromJSON(json['entitySelection']),
        'clearanceRuleHandles': json['clearanceRuleHandles'] == null ? undefined : json['clearanceRuleHandles'],
        'goodlistEnabled': json['goodlistEnabled'] == null ? undefined : json['goodlistEnabled'],
        'useOnlyScreenedEntities': json['useOnlyScreenedEntities'] == null ? undefined : json['useOnlyScreenedEntities'],
    };
}

export function InternalApiScreeningFlowTestToJSON(json: any): InternalApiScreeningFlowTest {
    return InternalApiScreeningFlowTestToJSONTyped(json, false);
}

export function InternalApiScreeningFlowTestToJSONTyped(value?: InternalApiScreeningFlowTest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entitySelection': InternalApiScreeningFlowTestEntitySelectionToJSON(value['entitySelection']),
        'clearanceRuleHandles': value['clearanceRuleHandles'],
        'goodlistEnabled': value['goodlistEnabled'],
        'useOnlyScreenedEntities': value['useOnlyScreenedEntities'],
    };
}

